/** Translation resources for the admin module. */
export const adminTranslations = {
    CS: {
        admin: {
            code: 'Kód',
            discriminator: 'Diskriminátor',
            userEnable: 'Uživatelské oprávnění',
            permissions: 'Oprávnění',
            controller: 'Kontejner',
            action: 'Akce',
            comment: 'Popis',
            discriminatorLoadingError: 'Načtení diskriminátorů',
            newPermission: 'Oprávnění',
            createNewPermission: 'Vytvoření nového oprávnění',
            editPermission: 'Úprava oprávnění',
            confirmDeleteRow: 'Tato akce může mít negativní vliv na celou aplikaci. Opravdu chcete oprávnění odstranit?',
            userEnableRole: 'Uživatelská role',
            name: 'Název',
            subordinateAssignedRoles: 'Přiřazené role',
            subordinateUnassignedRoles: 'Zbývající role',
            subordinateRoles: 'Podřízené role',
            subordinateRolesDisabled: 'Role je podřízena jiným rolím.',
            newRole: 'Vytvoření nové role',
            role: 'Role',
            editRole: 'Úprava role',
            roles: 'Role',
            unassignedPermissions: 'Zbývající oprávnění',
            assignedPermissions: 'Přiřazená oprávnění',
            missingScripts: 'Chybějící scripty',
            deploymentDate: 'Datum nasazení',
            library: 'Knihovna',
            applicationInfo: 'Informace o aplikaci',
            webName: 'eSkotWeb',
            externalLibraries: 'Verze externích knihoven',
            version: 'Verze',
            database: 'Databáze',
            eSkotDatabaseVersion: 'Verze databáze eSkot',
            access: 'Přístup',
            needSelectBreeder: 'Pro zobrazení dat vyberte subjekt',
            breederManagementScreenTitle: 'Správce uživatelů subjektu',
            associations: 'Svazy',
            approvedTo: 'Schváleno do',
            users: 'Uživatelé',
            authorizedOrganizations: 'Oprávněné organizace',
            breeders: 'Chovatelé',
            otherSubjects: 'Ostatní subjekty',
            farms: 'Hospodářství',
            createPermission: 'Vytvoření oprávnění',
            dateFromToIsInvalid: 'Schváleno do nesmí být dřív než Schváleno od.',
            farmsOrCentersMustBeFilled: 'Musí být vyplněno alespoň jedno z polí Hospodářství nebo Střediska.',
            loginName: 'Přihlašovací jméno',
            approvedFrom: 'Schváleno od',
            organizations: 'Střediska',
            allFarms: 'Všechna hospodářství',
            allFarmsAndOrganizations: 'Všechna hospodářství a střediska',
            farmsTooltip: 'Hospodářství:',
            organizationsTooltip: 'Střediska:',
            allOrganizations: 'Všechna střediska',
            areYouSureRemovingUserRoles: 'Opravdu chcete ukončit platnost všech rolí pro uživatele {{user}}?',
            areYouSureRemovingRoleForUsers: 'Opravdu chcete ukončit platnost role {{role}} pro všechny uživatele?',
            addAccessToBreeder: 'Přidat přístup chovateli {{breeder}}',
            updateAccessToBreeder: 'Upravit přístup chovateli {{breeder}}',
            addAccessToUser: 'Přidat přístup uživateli',
            confirmRemovingUserRoles: 'Opravdu chcete ukončit platnost všech rolí pro uživatele {{user}}?',
            confirmRemovingRoleForUsers: 'Opravdu chcete ukončit platnost role {{role}} pro všechny uživatele?',
            subjectHasNoFarms: 'Subjekt nemá žádné hospodářství.',
            addAccessToAssociation: 'Přidat přístup svazu {{association}}',
            subjectHasNoCenters: 'Subjekt nemá žádné organizační centra.',
            cannotCreateRecord: 'Není možné vytvořit záznam, uživatel {{user}} není členem žádného subjektu.',
            updateAccessToAssociation: 'Upravit přístup svazu {{association}}',
            updateAccessToOrganization: 'Upravit přístup organizaci {{organization}}',
            addAccessToOrganization: 'Přidat přístup organizaci {{organization}}',
            updateAccessToOtherSubject: 'Upravit přístup subjektu {{otherSubject}}',
            addAccessToOtherSubject: 'Přidat přístup subjektu {{otherSubject}}',
            confirmRemovingRoleForSubject: 'Opravdu chcete ukončit platnost role {{role}} pro subjekt?',
            needSelectOtherSubject: 'Pro zobrazení dat vyberte organizaci',
            permissionAdded: 'Oprávnění bylo úspěšně přidáno.',
            deletePermission: 'Odstranění oprávnění',
            needSelectAssociation: 'Pro zobrazení dat vyberte svaz',
            permissionDeleted: 'Oprávnění bylo úspěšně odstraněno.',
            deleteRole: 'Odstranění role',
            roleDeleted: 'Role byla úspěšně odstraněna.',
            loadRole: 'Načtení role',
            loadCenters: 'Načtení center',
            loadUserDetail: 'Načtení uživatele',
            subjectsLoading: 'Načítání subjektů',
            addPermissionToRole: 'Přidání oprávnění k roli',
            removePermissionFromRole: 'Odebrání oprávnění roli',
            roleEdited: 'Role byla úspěšně upravena.',
            createRole: 'Vytvoření role',
            roleAdded: 'Role byla úspěšně přidána.',
            permissionEdited: 'Oprávnění bylo úspěšně upraveno.',
            updateUserMembership: 'Úprava člena subjektu',
            userMembershipEdited: 'Člen subjektu byl úspěšně upraven.',
            createUserMembership: 'Přidání člena subjektu',
            userMembershipCreated: 'Člen subjektu byl úspěšně přidán.',
            deleteUserContact: 'Odstranění kontaktu',
            contactDeleted: 'Kontakt byl úspěšně odstraněn.',
            updateContact: 'Upravení kontaktu',
            contactUpdated: 'Kontakt byl úspěšně upraven.',
            createContact: 'Vytvoření kontaktu',
            contactAdded: 'Kontakt byl úspěšně přidán.',
            removeRolesForUser: 'Ukončení platnosti rolí',
            removeRolesForUserSuccess: 'Platnost rolí pro uživatele byla úspešně ukončena.',
            removeUsersFromRole: 'Ukončení platnosti role',
            removeUsersFromRoleSuccess: 'Platnost role pro uživatele byla úspešně ukončena.',
            loadDetail: 'Načtení detailu',
        },
    },
    EN: {
        admin: {
            permissions: 'Permissions',
            code: 'Code',
            discriminator: 'Discriminator',
            userEnable: 'User permission',
            controller: 'Controller',
            action: 'Action',
            comment: 'Comment',
            discriminatorLoadingError: 'Loading of discriminators',
            newPermission: 'Permission',
            createNewPermission: 'Create new permission',
            editPermission: 'Edit permission',
            confirmDeleteRow: 'This action may have a negative effect on the entire application. Are you sure you want to remove the permission?',
            userEnableRole: 'User role',
            name: 'Name',
            subordinateAssignedRoles: 'Assigned roles',
            subordinateUnassignedRoles: 'Unassigned roles',
            subordinateRoles: 'Subordinate roles',
            subordinateRolesDisabled: 'Role is subordinate to other roles.',
            newRole: 'Create new role',
            role: 'Role',
            roles: 'Roles',
            subjectsLoading: 'Loading of subjects',
            editRole: 'Edit role',
            unassignedPermissions: 'Unassigned permissions',
            assignedPermissions: 'Assigned permissions',
            missingScripts: 'Missing scripts',
            deploymentDate: 'Deployment date',
            library: 'Library',
            applicationInfo: 'Application information',
            webName: 'eSkotWeb',
            externalLibraries: 'External libraries versions',
            version: 'Version',
            database: 'Database',
            eSkotDatabaseVersion: 'eSkot database version',
            access: 'Přístup',
            needSelectBreeder: 'Select a subject to display data',
            authorizedOrganizations: 'Organizations',
            associations: 'Associations',
            otherSubjects: 'Other subjects',
            breeders: 'Breeders',
            breederManagementScreenTitle: 'Subject user management',
            dateFromToIsInvalid: 'Approved to date cannot be earlier than the approved from date.',
            farmsOrCentersMustBeFilled: 'At least one of the fields Farms or Centers must be filled.',
            areYouSureRemovingUserRoles: 'Are you sure you want to remove all roles for user {{user}}?',
            areYouSureRemovingRoleForUsers: 'Are you sure you want to remove role {{role}} for all users?',
            addAccessToBreeder: 'Add access to breeder {{breeder}}',
            updateAccessToBreeder: 'Edit access to breeder {{breeder}}',
            allFarms: 'All farms',
            allFarmsAndOrganizations: 'All farms and organization centers',
            farmsTooltip: 'Farms:',
            organizationsTooltip: 'Organization centers:',
            allOrganizations: 'All organization centers',
            farms: 'Farms',
            approvedTo: 'Approved to',
            approvedFrom: 'Approved from',
            organizations: 'Organizations',
            loginName: 'Login name',
            addAccessToUser: 'Add access to user',
            subjectHasNoFarms: 'Subject has no farms.',
            subjectHasNoCenters: 'Subject has no organization centers.',
            cannotCreateRecord: 'Cannot create record, user {{user}} is not a member of subject.',
            addAccessToAssociation: 'Add access to association {{association}}',
            needSelectAssociation: 'Select an association to display data',
            users: 'Users',
            updateAccessToAssociation: 'Update access to association {{association}}',
            updateAccessToOrganization: 'Update access to organization {{organization}}',
            addAccessToOrganization: 'Add access to organization {{organization}}',
            needSelectOtherSubject: 'Select an organization to display data',
            updateAccessToOtherSubject: 'Update access to subject {{otherSubject}}',
            addAccessToOtherSubject: 'Add access to subject {{otherSubject}}',
            confirmRemovingRoleForSubject: 'Are you sure you want to remove role {{role}} for subject?',
            createPermission: 'Create permission',
            permissionAdded: 'Permission was successfully added.',
            deletePermission: 'Delete permission',
            permissionDeleted: 'Permission was successfully deleted.',
            deleteRole: 'Delete role',
            roleDeleted: 'Role was successfully deleted.',
            loadRole: 'Load role',
            loadCenters: 'Load centers',
            loadUserDetail: 'Load user',
            addPermissionToRole: 'Add permission to role',
            removePermissionFromRole: 'Remove permission from role',
            roleEdited: 'Role was successfully edited.',
            createRole: 'Create role',
            confirmRemovingUserRoles: 'Are you sure you want to remove all roles for user {{user}}?',
            confirmRemovingRoleForUsers: 'Are you sure you want to remove role {{role}} for all users?',
            roleAdded: 'Role was successfully added.',
            permissionEdited: 'Permission was successfully edited.',
            updateUserMembership: 'Edit of user in subject',
            userMembershipEdited: 'User in subject was successfully edited.',
            createUserMembership: 'Create of user in subject',
            userMembershipCreated: 'User in subject was successfully created.',
            deleteUserContact: 'Delete user contact',
            contactDeleted: 'Contact was successfully deleted.',
            updateContact: 'Edit user contact',
            contactUpdated: 'Contact was successfully edited.',
            createContact: 'Contact contact',
            contactAdded: 'Contact was successfully added.',
            removeRolesForUser: 'Removing roles for the user',
            removeRolesForUserSuccess: 'The user\'s roles have been successfully removed.',
            removeUsersFromRole: 'Removing users from role',
            removeUsersFromRoleSuccess: 'The role\'s users have been successfully removed.',
            loadDetail: 'Load detail',
        },
    },
};
